import {toggleBodyScroll} from '../base/utils';

class SearchBar {
    constructor($element, topBar) {
        this.$searchWrap = $element;
        this.topBar = topBar;
        this.$searchTrigger = document.querySelectorAll('.js-search-trigger');
        this.$searchClose = $element.querySelector('.js-search-close');
        this.$searchInput = $element.querySelector('.header-search-query');

        this.init();
    }

    init() {
        [...this.$searchTrigger].forEach(el => el.addEventListener('click', this.open.bind(this)));
        this.$searchClose.addEventListener('click', this.close.bind(this));
        this.$searchInput.addEventListener('focus', this.focus.bind(this));
        this.$searchInput.addEventListener('blur', this.blur.bind(this));
        document.body.addEventListener('menu', this.toggleMenu.bind(this));
    }

    open() {
        this.topBar.toggleMenu(true);
        document.body.classList.add('search-open');
        this.$searchInput.focus();
        this.$searchInput.select();
    }

    close(doCloseMenu = true) {
        if (doCloseMenu) {
            this.topBar.toggleMenu(false);
        }
        document.body.classList.remove('search-open');
        document.body.classList.remove('search-open-no-overlay');
    }

    toggleMenu(data) {
        let isOpen = data.detail;

        if (!isOpen) {
            this.close(false);
        }
    }

    focus() {
        this.$searchWrap.classList.add('search-focus');
    }

    blur() {
        this.$searchWrap.classList.remove('search-focus');
    }
}

export default SearchBar;
